import { render } from "./StateWrapper.vue?vue&type=template&id=2bcd2f1d"
import script from "./StateWrapper.vue?vue&type=script&lang=js"
export * from "./StateWrapper.vue?vue&type=script&lang=js"

import "./StateWrapper.vue?vue&type=style&index=0&id=2bcd2f1d&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__